import React from 'react';
import { Vote, CheckCircle2, Clock, Users } from 'lucide-react';

const activeVotes = [
  {
    id: 1,
    title: 'Presupuesto Anual 2026',
    deadline: 'Vence en 3 días',
    voted: 45,
    total: 120,
    status: 'active',
  },
  {
    id: 2,
    title: 'Renovación Área de Juegos',
    deadline: 'Vence en 1 semana',
    voted: 78,
    total: 120,
    status: 'active',
  },
];

export function VotingWidget() {
  return (
    <div className="space-y-3">
      {activeVotes.map((vote) => (
        <div key={vote.id} className="p-3 bg-gray-50 rounded-lg">
          <div className="flex items-start justify-between gap-2">
            <div className="flex-1 min-w-0">
              <p className="font-medium text-sm text-gray-900 truncate">{vote.title}</p>
              <div className="flex items-center gap-2 mt-1 text-xs">
                <span className="flex items-center gap-1 text-orange-600">
                  <Clock className="w-3 h-3" /> {vote.deadline}
                </span>
              </div>
            </div>
            {vote.status === 'active' && (
              <span className="flex-shrink-0 px-2 py-0.5 bg-green-100 text-green-700 text-xs rounded-full">
                Activa
              </span>
            )}
          </div>

          {/* Progress */}
          <div className="mt-3">
            <div className="flex items-center justify-between text-xs text-gray-500 mb-1">
              <span className="flex items-center gap-1">
                <Users className="w-3 h-3" />
                Participación
              </span>
              <span>{Math.round((vote.voted / vote.total) * 100)}%</span>
            </div>
            <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
              <div
                className="h-full bg-[#36CCD8] rounded-full transition-all"
                style={{ width: `${(vote.voted / vote.total) * 100}%` }}
              />
            </div>
            <p className="text-xs text-gray-500 mt-1">
              {vote.voted} de {vote.total} residentes han votado
            </p>
          </div>
        </div>
      ))}

      <button className="w-full py-2 text-sm font-medium text-[#36CCD8] hover:text-[#2DB8C4] hover:bg-[#36CCD8]/5 rounded-lg transition-colors">
        Ver todas las votaciones →
      </button>
    </div>
  );
}

export default VotingWidget;
